import { useRef } from "react";
import "./Portfolio.scss";
import { motion, useInView } from "framer-motion";
// import { FiMapPin } from "react-icons/fi";

import backgroundImage from "../../Assets/images/img11.jpg";
import img1 from "../../Assets/images/portfolio/sunroom1.png";
import img2 from "../../Assets/images/portfolio/adu1.png";
import img3 from "../../Assets/images/portfolio/container1.png";
import img4 from "../../Assets/images/portfolio/interiordesign2.png";
import img5 from "../../Assets/images/portfolio/deckdesign2.png";
import img6 from "../../Assets/images/portfolio/patiocover1.jpg";
import img7 from "../../Assets/images/portfolio/officespace4.png";
import img8 from "../../Assets/images/portfolio/ViewTower.jpg";
import img9 from "../../Assets/images/portfolio/Gaumukhi1.jpg";
import img10 from "../../Assets/images/portfolio/bluehillpark1.jpg";
import img11 from "../../Assets/images/portfolio/FoodMahal1.jpg";
import img12 from "../../Assets/images/portfolio/naiet1.png";
import img13 from "../../Assets/images/portfolio/Multi-CulturalMuseum1.jpg";
import img14 from "../../Assets/images/portfolio/KavreGumba1.jpg";
import img15 from "../../Assets/images/portfolio/coveredhall.png";
import img16 from "../../Assets/images/portfolio/ChandragiriStadium1.jpg";
import img17 from "../../Assets/images/portfolio/batukbhairav1.jpg";
import img18 from "../../Assets/images/portfolio/PadamPokhariStadium1.jpg";
import img19 from "../../Assets/images/portfolio/shop1.jpg";
import img20 from "../../Assets/images/portfolio/ShivaStatue1.jpg";

const projects = [
  {
    title: "3D modelling and rendering for Sunroom Design",
    location: "New York, NY",
    status: "Completed",
    image: img1,
    scope: "Architecture, Detailed Structural Design. ",
  },
  {
    title: "Accessory Dwelling Unit (ADU) Design",
    location: "Hollywood, Florida",
    status: "Under Construction",
    image: img2,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Shipping Container Design",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img3,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Interior Design",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img4,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Deck Design",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img5,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Patio Cover, Pergola and Exterior Design",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img6,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Office Space Design",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img7,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Padam Pokhari View Tower",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img8,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Gaumukhi Primary Hospital",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img9,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Blue Hill Park",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img10,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Modern Food Mahal",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img11,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Nepal Army Institute of Engineering Technology",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img12,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "SMulti-cultural Museum",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img13,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Gumba Structure",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img14,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Multi-purpose Truss Hall",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img15,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Chandragiri Stadium",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img16,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Batuk Bhairav Gale Park",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img17,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Padam Pokhari Stadium",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img18,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Hyper-mart & Café",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img19,
    scope: "Architecture, Detailed Structural Design.",
  },
  {
    title: "Shiva Statue",
    location: "Spotswood, NJ",
    status: "Completed",
    image: img20,
    scope: "Architecture, Detailed Structural Design.",
  },
];

const Portfolio = () => {
  const titleRef = useRef(null);
  const isInView = useInView(titleRef, { once: true, amount: 0.1 });

  return (
    <section className="portfolio-section">
      <div
        className="portfolio-banner"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="portfolio-overlay" />
        <div className="portfolio-text container text-left">
          <motion.div
            ref={titleRef}
            initial={{ opacity: 0, y: 100 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          >
            <h5>PORTFOLIO</h5>
          </motion.div>
        </div>
      </div>

      <div className="white-container">
        <div className="inner-container" />
      </div>

      <div className="portfolio-title">
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <h4>
            Where ideas become landmarks <br /> Our project gallery
          </h4>
        </motion.div>
      </div>

      <div className="portfolio-grid container">
        {projects.map((project) => (
          <motion.div
            className="portfolio-card"
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
          >
            <img
              className="card-bg-image"
              src={project.image}
              alt={project.title}
            />

            <div className="card-info">
              <span
                className={`status-badge ${project.status
                  .toLowerCase()
                  .replace(" ", "-")}`}
              >
                {project.status}
              </span>
              <h4 className="project-title">{project.title}</h4>
              <hr />
              <p>Scope :</p>
              <h2 className="project-description">{project.scope}</h2>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
